export class ExerciseGoalType {
	static WeightAndRepsGoal = 1;
	static WeightGoal = 2;
	static RepsGoal = 3;
	static DistanceAndTimeGoal = 5;
	static DistanceGoal = 6;
	static TimeGoal = 7;
	static WeightAndTimeGoal = 9;
}